import { NgClass } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';


@Component({
    selector: 'app-fp-navbar',
    imports: [RouterLink, RouterLinkActive, NgClass],
    templateUrl: './fp-navbar.component.html',
    styleUrl: './fp-navbar.component.scss'
})
export class FpNavbarComponent {

    // Mobile Menu Toggle
    classApplied = false;

    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    closeMenu() {
        this.classApplied = false;
    }
    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    // Smooth Scroll to Section with Center Alignment
    smoothScroll(sectionId: string) {
        const element = document.getElementById(sectionId);
        if (element) {
            // Calculate position to center the section with navbar offset
            const navbarHeight = 80; // Adjust based on your navbar height
            const elementPosition = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
            const scrollOffset = elementPosition - (window.innerHeight / 2);

            // Scroll to centered position
            window.scrollTo({
                top: scrollOffset,
                behavior: 'smooth'
            });
            
            // Close mobile menu after navigation
            this.classApplied = false;
        }
    }

}